module.exports = __webpack_public_path__ + "static/media/credit.90dc77a4.scss";


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/credit/credit.scss
// module id = 215
// module chunks = 0